var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _c("div", { staticClass: "bg-surface-secondary w-100" }, [
      _c("header", { staticClass: "bg-surface-primary border-bottom" }, [
        _c("div", { staticClass: "container-fluid py-4" }, [
          _c("div", { staticClass: "row align-items-center" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "d-flex align-items-center gap-4" }, [
                _c("div", [
                  _c("button", {
                    staticClass: "btn-close text-xs",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$router.go(-1)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vr opacity-20 my-1" }),
                _vm._v(" "),
                _c("h1", { staticClass: "h4 ls-tight" }, [
                  _vm._v("Actualizar arancel top"),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-auto" }, [
              _c("div", { staticClass: "hstack gap-2 justify-content-end" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-h btn-success px-3",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.UPDATE()
                      },
                    },
                  },
                  [
                    _vm.count == 1
                      ? _c(
                          "div",
                          {
                            staticClass: "spinner-border spinner-border-sm",
                            attrs: { role: "status" },
                          },
                          [
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("Loading..."),
                            ]),
                          ]
                        )
                      : _c("span", [_vm._v("Guardar cambios")]),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("main", { staticClass: "py-6 bg-surface-secondary" }, [
        _c(
          "div",
          { staticClass: "container-fluid max-w-screen-md vstack gap-3" },
          [
            _c(
              "div",
              [
                _c("small", { staticClass: "input-title" }, [
                  _vm._v("Descripción"),
                ]),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.description,
                      expression: "data.description",
                    },
                  ],
                  staticClass: "form-control form-control-sm",
                  class: _vm.errors.description ? "is-invalid" : "",
                  domProps: { value: _vm.data.description },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "description", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.description, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("small", { staticClass: "input-title" }, [
                  _vm._v("Arancel"),
                ]),
                _vm._v(" "),
                _c("search-tax", {
                  attrs: { tax: _vm.data.tax },
                  model: {
                    value: _vm.data.tax_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "tax_id", $$v)
                    },
                    expression: "data.tax_id",
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.tax_id, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }